import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import VueNumber from 'vue-number-animation'
import SuiVue from 'semantic-ui-vue'
import firebase from 'firebase/app'
import 'firebase/analytics'

Vue.config.productionTip = false
Vue.use(SuiVue)
Vue.use(VueNumber)

const firebaseConfig = {
  apiKey: "AIzaSyDROY3AMhkPK6llVFgtqaLbIdFxOP_KU9k",
  authDomain: "business-map-274423.firebaseapp.com",
  databaseURL: "https://business-map-274423.firebaseio.com",
  projectId: "business-map-274423",
  storageBucket: "business-map-274423.appspot.com",
  messagingSenderId: "964469269799",
  appId: "1:964469269799:web:31687a32d137c32b4ab502",
  measurementId: "G-NBWTGK722D"
}
firebase.initializeApp(firebaseConfig)
export const analytics = firebase.analytics()

new Vue({
  render: h => h(App),
}).$mount('#app')